// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminCancelInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminCancelInput — body for POST /subscriptions/admin/cancel.
 *
 * S12/M3d: the staff console's manual cut. One field on purpose — the cut is
 * always aimed at a specific subscription row, never at "the franchise's
 * current subscription", because resolving that here would be a second opinion
 * about which row is live and the roster already answered it.
 */
import { registerContract } from './validate'

export interface Subscriptions_AdminCancelInput {
subscription_id: number
}

registerContract('Subscriptions_AdminCancelInput', {
  subscription_id: { type: 'number',  required: true },
})
